export default __webpack_public_path__ + "static/media/ROSE.c14c05d2.png";